// extracted by mini-css-extract-plugin
export default {"groupZone":"GroupArea_groupZone__Om3U8","title":"GroupArea_title__stHWq","groupsBox":"GroupArea_groupsBox__bHj+-","addButton":"GroupArea_addButton__8bmeV"};